import { Shadow, Skeleton, HStack, VStack } from '@genial/components';
import { Spacing, Color, BoxRadius } from '@genial/design-tokens';
interface ProductMobileCardLoadingProps {
  fieldsAmount: number;
}
export const ProductMobileCardLoading = ({ fieldsAmount }: ProductMobileCardLoadingProps) => {
  return (
    <VStack space={Spacing['stack.xxxs']} pb={Spacing['stack.xxxs']}>
      <Shadow testId="shadow" level={1} borderRadius="8px">
        <VStack
          space={Spacing['inline.xxxs']}
          p={Spacing['inline.xxs']}
          justifyContent="space-between"
          alignItems="center">
          <HStack
            w="full"
            justifyContent="space-between"
            alignItems="center"
            space={Spacing['inline.xxs']}>
            <Skeleton
              height="48px"
              width="54px"
              borderRadius={BoxRadius.sm}
              endColor={Color['brand.primary.lightest']}
            />
            <Skeleton
              height="20px"
              width="20px"
              borderRadius={BoxRadius.sm}
              endColor={Color['brand.primary.lightest']}
            />
          </HStack>

          {Array.from({ length: fieldsAmount }).map((_, index) => (
            <HStack
              key={index}
              w="full"
              justifyContent="space-between"
              alignItems="center"
              space={Spacing['inline.quarck']}
              borderBottomColor={Color['neutral.lightest']}
              borderBottomWidth="1px"
              pb={Spacing['inline.nano']}>
              <Skeleton
                height="14px"
                width="40%"
                borderRadius={BoxRadius.sm}
                endColor={Color['brand.primary.lightest']}
              />
              <Skeleton
                height="14px"
                width="20%"
                borderRadius={BoxRadius.sm}
                endColor={Color['brand.primary.lightest']}
              />
            </HStack>
          ))}

          <HStack
            w="full"
            justifyContent="flex-end"
            alignItems="center"
            space={Spacing['inline.nano']}>
            <Skeleton
              height="20px"
              width="20%"
              borderRadius={BoxRadius.sm}
              endColor={Color['brand.primary.lightest']}
            />
          </HStack>
        </VStack>
      </Shadow>
    </VStack>
  );
};
